import React from "react";
import {
    useAppState
} from "./RetailerFitGuide_StateContext";
export const RetailerFitGuide_Footer = () => {

    const {
        translations,
    } = useAppState();

    const getContactInfo = () => {

        switch (_THULEDATA.SitecoreLanguage.split("-")[1]) {
            case "US":
                return {
                    email: "usdealers@thule.com",
                    phone: "800-848-5322"
                }
            case "CA":
                return {
                    email: "dealers@thule.com",
                    phone: "888-361-8967"
                }
            default:
                return {
                    email: "-",
                    phone: "-"
                }
        }
    }
    const contactInfo = getContactInfo();

    return <footer className="retailerFitGuide_Footer">
        <div className="layout__content">
            <div className="thule-container w-100">
                <h2 className="paragraph--lead mb-0 text-color--white">{translations.support}</h2>
                <div className="retailerFitGuide_FooterContent">
                    <address className="pt-6">
                        <a href={`mailto:${contactInfo.email}`} className="mb-5 text-decoration-underline">{contactInfo.email}</a>
                        <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
                    </address>
                    {/* <div className="retailerFitGuide_FooterBorder"></div> */}
                    {/* <div>
                    <a className="mb-5" href="https://www.thule.com/en-us/">thule.com</a>
                    <a href="https://www.thule.net/en-us/">thule.net</a>
                </div> */}
                    <div>
                        © {new Date().getFullYear()} Thule AB
                    </div>
                </div>
            </div>
        </div>
    </footer>
}